import Firestore from '../initFirebase'
import {
  handleErrorInCatch,
  notSavedInAnonymous,
  notSavedInSharing,
  savingEnd,
  savingStart
} from '../../helper/functions'
import firebase from 'firebase/app'
import { globalOnDemandVars } from '../../helper/context'
import * as shortId from 'shortid'

export async function createMediaItemAndReturnGlobalId (localId, type, title, content) {
  if (globalOnDemandVars.isSharing()) {
    notSavedInSharing()
    return
  }
  if (globalOnDemandVars.userData().isAnonymous) {
    notSavedInAnonymous()
    return shortId.generate()
  }

  if (process.env.NODE_ENV !== 'production') {
    console.tron.display({
      name: 'createMediaItemAndReturnGlobalId 시작',
      preview: localId,
      value: {
        localId, type, title, content, dateNow: Date.now()
      }
    // , important: true
    })
  }

  const collectionReference = Firestore.collection('users').doc(globalOnDemandVars.userData().uid).collection('MediaItems')
  let globalId
  const data = {
    localId: localId,
    title,
    type,
    content: typeof content === 'string' ? content : JSON.stringify(content),
    inTypeItems: true,
    typeOrder: 0,
    creationTimeValue: (Math.floor(Date.now() * 0.001))
  }

  try {
    savingStart()
    if (globalOnDemandVars.isOnline()) {
      await collectionReference.add(data).then((ref) => {
        globalId = ref.id
        if (process.env.NODE_ENV !== 'production') {
          console.tron.log(`createMediaItemAndReturnGlobalId - ${globalId}`)
        }
      })
      await collectionReference.doc('Count').update({
        [type]: firebase.firestore.FieldValue.increment(1)
      })
    } else {
      globalId = shortId.generate()
      await collectionReference.doc(globalId)
        .set(data)
      await collectionReference.doc('Count').update({
        [type]: firebase.firestore.FieldValue.increment(1)
      })
    }
    savingEnd()
  } catch (e) {
    handleErrorInCatch(e, 'createData.js')
  }
  // const result = await client.mutate(buildMutation(client,
  //   gql(createMediaItem),
  //   {
  //     inputType: gql(CreateMediaItemInput),
  //     variables: {
  //       input: {
  //         localId: localId,
  //         title,
  //         type,
  //         content: typeof content === 'object' ? JSON.stringify(content) : content,
  //         inTypeItems: true,
  //         typeOrder: 0,
  //         creationTimeValue: (Math.floor(Date.now() * 0.001))
  //       }
  //     }
  //   },
  //   (_variables) => [ gql(getMediaItem) ],
  //   'MediaItem')).catch(e => handleErrorInCatch(e))

  // console.tron.display({
  //   name: 'createMediaItem',
  //   preview: localId,
  //   value: {
  //     result: collectionReference.doc(docRef.id).get().data()
  //   }
  //   // , important: true
  // })
  return String(globalId)
}
